import * as React from 'react';
import { useAppDispatch } from '../../hooks/index';
import { setIsHome } from '../../redux/MiscSlice';
import Page from '../Page';
import GeoLocationSelector from './GeoLocationSelector';





const PublicReportsMenu = () => {
    const dispatch = useAppDispatch();
    dispatch(setIsHome(false));
    return (
        <Page>
            <GeoLocationSelector />
        </Page>
    );
}

export default PublicReportsMenu;